/* JS */
window.jQuery(function () {
  if (typeof window.isAldi !== 'undefined' && window.isAldi === true) {
    return
  }
  window.jQuery('a:contains(Zufriedenheitsbefragung)').parent().hide()
  window.jQuery('a:contains(ACC)').parent().hide()
  window.jQuery('a:contains(Shortcodes drucken)').parent().hide()
})



// WEBPACK FOOTER //
// ./src/editor-bar.js